export class TTTOutCocModule
{
patcode = '' ;
tttdate = '' ;
ttttype = '' ;
tttname = '' ;
ttttoxicity = '' ;
tttenddate = '' ;
tttnumb = '' ;
tttduration_dose = '' ;
tttnotes = '' ;
tttresponse = '' ;
compcode = '1' ;
userid = 'sa' ;
modifieddate = '2022-01-01' ;

}
